import cn from 'classnames'
import moment from 'moment'
import React from 'react'
import {
  NotificationListResponse,
  NotificationStatus,
} from 'src/models/notifications.models'

import style from './NotificationItem.style'

interface NotificationItemProps {
  notification: NotificationListResponse
}

const NotificationItem = ({ notification }: NotificationItemProps): React.ReactElement => {
  const isTimestampToday = moment(notification.timestamp).isSame(moment(), 'day')

  return (
    <div
      className={cn('NotificationItem', notification.id)}
      css={style}
    >
      <div className={cn('NotificationItem-topRow')}>
        <div className={cn('NotificationItem-topRow-title')}>
          {notification.subject}
        </div>
        <div className={cn('NotificationItem-topRow-timestamp')}>
          {isTimestampToday
            ? moment(notification.timestamp).format('LT')
            : moment(notification.timestamp).format('l')
          }
        </div>
      </div>
      <div className={cn('NotificationItem-bottomRow')}>
        <div className={cn('NotificationItem-bottomRow-body')}>
          {notification.body}
        </div>
        <div
          className={cn('NotificationItem-bottomRow-unreadDot', {
            unread: notification.status === NotificationStatus.unread,
          })}
        />
      </div>
    </div>
  )
}

export default NotificationItem
